window.ACH_LOCATION_DATA = {
  zones: {
    // 99 MIN o GRATIS (lista exacta de tu página)
    lima_99: [
      "Ate - Vitarte",
      "Ate - Salamanca",
      "La Molina",
      "Santiago de Surco",
      "San Borja",
      "San Isidro",
      "Miraflores",
      "Barranco",
      "Surquillo",
      "Lince",
      "La Victoria",
      "Jesús María",
      "Pueblo Libre",
      "Mayorazgo"
    ],

    // TE LLEGA HOY (Lima Moderna)
    lima_hoy: [
      "Barranco",
      "Breña",
      "Callao 1",
      "Comas",
      "Cercado de Lima",
      "Chorrillos",
      "El Agustino",
      "Independencia",
      "Jesús María",
      "La Molina",
      "La Victoria",
      "Lince",
      "Los Olivos",
      "Magdalena del Mar",
      "Miraflores",
      "Pueblo Libre",
      "Rímac",
      "San Borja",
      "San Isidro",
      "San Luis",
      "San Miguel",
      "San Juan de Lurigancho",
      "San Juan de Miraflores",
      "Santa Anita",
      "Santiago de Surco",
      "San Martín de Porres",
      "Surquillo"
    ],

    // 24–48h (Lima Periférica + Playas)
    lima_24_48: [
      "Ancón",
      "Carabayllo",
      "Chaclacayo",
      "Cieneguilla",
      "Ate - Huaycán",
      "Lurigancho - Chosica",
      "Lurín",
      "Pachacámac",
      "Santa Rosa",
      "Ate - Santa Clara",
      "Villa María del Triunfo",
      "Puente Piedra",
      "Villa El Salvador",
      "Ventanilla",
      "Asia",
      "Aspitia",
      "Chilca",
      "San Bartolo",
      "Santa María del Mar",
      "San Andrés",
      "Pucusana",
      "Punta Hermosa",
      "Punta Negra"
    ]
  },

  messages: {
    lima_99: "99 MIN o es GRATIS (según horario y cobertura).",
    lima_hoy: "Llega HOY (válido para Lima Moderna, según horario y cobertura).",
    lima_24_48: "Llega en 24–48h (Lima periférica / playas, según cobertura).",
    provincia: "Provincias: aprox. 2–5 días hábiles (Shalom/Olva según destino).",
    unknown: "Elige tu ubicación para calcular tu entrega."
  }
};
